/**
 * 이미지를 배너 비율에 맞게 리사이즈 (고해상도 유지)
 * - 배너: 1200×400 (3:1), quality 0.92
 * - 프로필: 400×400 (1:1), quality 0.90
 */

type ImagePreset = 'banner' | 'profile';

const PRESETS: Record<ImagePreset, { width: number; height: number; quality: number }> = {
  banner: { width: 1200, height: 400, quality: 0.92 },
  profile: { width: 400, height: 400, quality: 0.90 },
};

export const resizeImage = (file: File, preset: ImagePreset = 'banner'): Promise<File> => {
  const { width: targetW, height: targetH, quality } = PRESETS[preset];

  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext('2d')!;

        // 고품질 렌더링
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        // cover crop: 원본 비율 유지하면서 중앙 크롭
        const srcRatio = img.width / img.height;
        const tgtRatio = targetW / targetH;

        let sx = 0, sy = 0, sw = img.width, sh = img.height;

        if (srcRatio > tgtRatio) {
          // 원본이 더 넓음 → 좌우 잘라냄
          sw = img.height * tgtRatio;
          sx = (img.width - sw) / 2;
        } else {
          // 원본이 더 좁음 → 위아래 잘라냄
          sh = img.width / tgtRatio;
          sy = (img.height - sh) / 2;
        }

        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, targetW, targetH);

        canvas.toBlob(
          (blob) => {
            if (!blob) { reject(new Error('Canvas toBlob failed')); return; }
            const resizedFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(resizedFile);
          },
          'image/jpeg',
          quality,
        );
      };
      img.onerror = reject;
      img.src = e.target?.result as string;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
